export const googleReviews = [
  {
    text: "Herşey düzenli ve belli kurallara göre işliyor süreç gayet başarılı ve kaldığımız yer fotoğraftakiler gibiydi villa sahibi abi sağolsun her süreçte ilgiliydi konum olarak manzara güzeldi memnun kaldık teşekkürler herşey için.",
    name: "Mustafa Oğuz",
    rating: 5,
  },
  {
    text: "İrem Hanım çok içten ve ilgiliydi.Kendisine teşekkür ederiz. İnşallah tatilimizde çok güzel geçer,aynı ilgiyi orada da bekliyoruz.",
    name: "mustafa özdemir",
    rating: 5,
  },
  {
    text: "Villa Villam aracılığıyla kiraladığımız Villa Nefise’de geçirdiğimiz tatilden çok memnun kaldık. Rezervasyon sürecinden tatilimizin sonuna kadar herhangi bir sorun yaşamadık. Villa, fotoğraflarda göründüğü gibi temiz, düzenli ve oldukça",
    name: "Okan Karaçil",
    rating: 5,
  },
  {
    text: "22-26 Nisan için Villa Cundayı kiraladık. Şu an da villadan yorum yazıyorum. Villayı havuz ısıtmalı kiraladık. Küçük çocuğumuz olduğu için özellikle bizim için havuzun sıcak olması önemliydi. Bunun için ekstra 8000 TL ödedik. Havuzun 2 gün",
    name: "didem uysal",
    rating: 5,
  },
  {
    text: "İlk defa villa kiraladım, çok duyduk sıkıntı yaşayanları, ancak villa villam ve Kalkan da konakladığımız villa mehtap sahibi Mehmet Bey çok ilgilendi, ev ve havuz çok temiz, havuz günlük temizlendi, plaj havlusu, normal havlu ve mutfak",
    name: "YILDIRIM ÇEVİK",
    rating: 5,
  },
  {
    text: "Villa myore 7 Geçirdiğimiz tatil boyunca her şey beklentimizin üzerindeydi. Villa son derece temiz, konforlu ve fotoğraflarda görüldüğünden bile daha güzeldi. Sessizliği,",
    name: "“mereşevi” reşat beytekin",
    rating: 5,
  },
  {
    text: "Yardım çok iyiydi. Verilen hizmetten çok memnun kaldım. Her şey hızlı ve sorunsuz bir şekilde çözüldü. Teşekkür ederim.",
    name: "Zeynep Senol",
    rating: 5,
  },
  {
    text: "Gerçektende çok guzel bir tatil yaşadık villamız aynı resimlerdeki gibiydi ve villa sahibi ailesi aşırı iyi insanlar aşırı ilgi gösterildi gece 1 de bile site bana yardımcı oldu rezervasyondan konaklamaya kadar her şey çok iyidi ısıtmalı",
    name: "erman sert",
    rating: 5,
  },
  {
    text: "Rezervasyonumuzu yaparken İrem hanım ile birlikle ilerledik. Sabırla yardımcı oldu. İlgisi için ayrıca teşekkür ediyorum. Sorunsuz bir şekilde en doğru adreste en iyi çalışanlarla tatilimizi planladık.",
    name: "demet özdemir",
    rating: 5,
  },
  {
    text: "Tek kelime ile mükemmel özellikte temizlik konusunda aşırı derecede iyi. Temizlik takıntısı olanlar hiç düşünmeden gelebilir. Onun dışında çok samimi bir meydana sahip esnaf çok güler yüzlü hizmet ve memnuniyet için ellerinden geleni yapıyorlar. Tam bir fiyat performans tatil diyebiliriz kaçırmayın..",
    name: "iso",
    rating: 5,
  },
  {
    text: "Villaya gerçekten bayıldık. Her şey en ince ayrıntısına kadar düşünülmüş, özellikle temizliği ve düzeni gerçekten harikaydı. Kendimizi evimizde gibi hissettik. Gönül rahatlığıyla tavsiye ediyoruz, tekrar gelmek için sabırsızlanıyoruz. Her şey için çok teşekkür ederiz! 🌸✨",
    name: "Gulistan Başkut",
    rating: 5,
  },
  {
    text: "Gördüğüm tüm firmalardan daha hızlı dönüş, daha iyi ilgi ve daha doğru bilgiyi bana aktardıkları için çok teşekkür ediyorum. Çalışanlarınızı tebrik ediyorum ve başarılarının devamını diliyorum. Ayrıca belirtmek isterim ki gece saat 23:00",
    name: "Abdullatif Terzi",
    rating: 5,
  },
  {
    text: "2023 yılında Kalkan bölgesindeki konaklamamızdan son derece memnun kaldığımız için bu yıl Fethiye için de yeniden tercih ettik. Rezervasyon sürecinden itibaren müşteri temsilcilerinin ilgisi, profesyonelliği ve çözüm odaklı yaklaşımı",
    name: "Gamze Ocaklı",
    rating: 5,
  },
  {
    text: "İrtibat kurduğumuz Sezen hanım her konuda çok yardımcı ve samimi iletişimi ile tereddütsüz güven duymamızı sağlamıştır. İlgisi ve yardımcı yaklaşım için kendisine teşekkür ediyoruz...",
    name: "Ömer KIRCA",
    rating: 5,
  },
  {
    text: "Çok hızlı ve sonuç odaklı bi rezervasyon süreci sunuyorlar. 2025 ve 2026 olarak 2 kere rezervasyon yaptım. Her ikisinde de gayet keyifli bir şekilde işlemleri tamamladım.",
    name: "Ahmet Korkut Tahaoğlu",
    rating: 5,
  },
  {
    text: "Bu villada 5 gün geçirdim ve gerçekten son derece memnun kaldım! Her şey harikaydı; villa tertemizdi, zevkle döşenmişti ve her detay ince düşünülmüştü. Ortam hem huzurlu hem de konforluydu.",
    name: "Seray Kutlu",
    rating: 5,
  },
  {
    text: "Hayatımda yaptığım en doğru tatil seçimlerinden biriydi! Villa hem tertemiz hem de inanılmaz konforluydu. Sessiz, huzurlu ve tamamen kafa dinlemelik bir ortamı var. Özellikle çocuklarla gelenler için çok rahat ve güvenli. Her detay",
    name: "Efsane Gokceoglu",
    rating: 5,
  },
  {
    text: "2026 Haziran ayı için şimdiden Villa Visal’ e rezervasyon yaptırdık. Rezervasyon sürecinde İrem Nur Hanım, Betül Hanım ve Sezen Hanım ile telefonda görüşmeler sağladık ve çok yardımcı oldular. Özellikle kendilerine teşekkürlerimi",
    name: "Belinay ŞERBETÇİ",
    rating: 5,
  },
  {
    text: "Antalya Kaşta Villa Eskizde kaldık. Villanın tüm detayları harikaydı ev sahibi çok ilgili ve güleryüzlü idi. Kafanızda soru işaretleri ile gitmiştik ama hepsi silindi gittiğimizde. Bizim için unutulmaz bir anı olarak kaldı.",
    name: "Şerife Karatoprak",
    rating: 5,
  },
  {
    text: "Faralyadaki Villa sparrow 1’de konakladık. Villa temiz ve çok güzeldi , eksik hiçbir şeyi yoktu, manzarası 10 numaraydı. Villa sahibi Gökhan Semerci bey’in ilgi ve alakası için çok teşekkür ederiz.",
    name: "Nilüfer Yavuz",
    rating: 5,
  },
  {
    text: "İki yıldır düzenli olarak geliyoruz ve çok memnunuz.Temiz düzenli ve huzurlu bir yer.Isletme sahipleri çok ilgili ve güler yüzlü. Kendi evimiz gibi hissediyoruz herkese tavsiye ederiz😊",
    name: "Meliha78.90 Melis",
    rating: 5,
  },
  {
    text: "Gerçekten güzel bi firma hepsine çok teşekkür ederim benimle rezervasyon boyunca ilgilendiler anında dönüş sağladılar kesinlikle tavsiye ederim",
    name: "Bahriye Onüçyıldız",
    rating: 5,
  },
  {
    text: "Villa kiralama sürecimiz çok hızlı ve sorunsuz ilerledi. Tüm işlemler güvenli bir şekilde tamamlandı. İlgi ve desteklerinden dolayı çok memnun kaldık, kesinlikle tavsiye ederim.",
    name: "hilal güvey",
    rating: 5,
  },
  {
    text: "Oldukça keyif aldığımız bir tatil geçirmekteyiz , rezervasyon departmanında bulunan Yasemin hanim'a teşekkür ederiz ☺️ kiralama esnasında herhangi bir problem ile karşılaşmadık extra bir ücret veya kabalık da görmediğimiz gibi ev sahipleri",
    name: "Onur Demir",
    rating: 5,
  },
  {
    text: "Rezervasyon süreci akıcı ve kolay. SMS, e-mail ve Whatsapp bidirinleri geliyor. Whatsapp hattı ile sorularınızı direkt sorabiliyorsunuz. Yardımcı oluyorlar her konuda.",
    name: "Süleyman Demircan",
    rating: 5,
  },
  {
    text: "Fethiye farkta maki ev için rezervasyon başlamasından satın alma işlemine kadar çok güzel ilgilendiler. Ve sorunsuz şekilde rezervasyon işlemini tamamladım. İlgileri ve güzel hizmetleri için çok teşekkür ederim 🙏🏻🌸",
    name: "BAHAR TUĞCU",
    rating: 5,
  },
  {
    text: "Gece yarısı bile çalışıyorlar whatsapp iletişimi kurdum destek oldular. Çok ilgilendiler tüm süreç boyunca, Teşekkürler.",
    name: "Berkay Colakoglu",
    rating: 5,
  },
  {
    text: "Yol biraz zorlu gelse de villayı gördükten sonra gerçekten değdi dedik. Villa harika içerisinde bütün ihtiyaçlarımızı giderecek ekipmanlar mevcut. Tost makinesi,kahve ve çay makinesi,fırın,mikrodalga çamaşır ve bulaşık makinesi her şey",
    name: "Fatih yılmaz",
    rating: 5,
  },
  {
    text: "Villa rezervasyonumuzda tarih değişikliği yapmak istediğimizde ev sahibinin katı kurallarına rağmen, villa villam müşteri hizmetlerinin desteği ile mağdur edilmeden talebimiz gerçekleştirildi.",
    name: "İrem Gülten",
    rating: 5,
  },
  {
    text: "Henüz sadece rezervasyon yaptırdık fakat rezervasyon aşamasında her türlü sorulara ve isteklere nazikçe geri dönüş ve destek sağladıkları için teşekkür ederiz",
    name: "Onur Çalışkanyürek",
    rating: 5,
  },
  {
    text: "Müşteri hizmetleri gayet kibar ve sorulara net cevap veriyorlar problem olması durumunda hemen ilgileniyorlar ben çiğdem hanımla görüştüm kendisine çok teşekkür ederim yardımları için :)",
    name: "Regaip Özveren",
    rating: 5,
  },
  {
    text: "Birebir ilgilendiler çalışanları güler yüzlü ve Çözüm odaklı Kesinlikle villa kiralarken iletişim olarak burayı tercih ederim villada kaldığım zamanda yorumu güncelleyeceğim ama gayet kiralarken birebir ilgilenen işletme İlginiz için teşekkür ederim",
    name: "Semanur Güllü",
    rating: 5,
  },
  {
    text: "Cansel hanıma ayrıca teşekkür ederiz tüm opsiyonlarını kullanarak harika enerjisi ile yerimizi tuttuk tatilimizi keyifle geçireceğiz inşallah",
    name: "kübra sezgin",
    rating: 5,
  },
  {
    text: "Temmuz ayı için rezervasyon için konuştuk çok ilgiliydi gayet açıklayıcı ve yardımcı olacak şekilde konuşma yaptık acenteden şuanlık bir sıkıntımız yok umarım tatildede bir sorun yaşamayız😌",
    name: "Meryem Nur",
    rating: 5,
  },
  {
    text: "İlk kiralama aşamasını tamalamak çok kolay ve akıcıydı. Tüm rezervasyon işlemlerini tamalayıp sözleşmeyi almam 2 dakika bile sürmedi. Bu gidişat villaya hiriş aşamasının da kolay ve keyifli olacağına dair iyi bir işaret…",
    name: "Çağlar Üçeş",
    rating: 5,
  },
  {
    text: "Villa Villam İle 2. Tatilimizi Planladık. Geçen Sene Ramazan Bayramı Tatili İçin Villa Kiraladık Gittiğimiz Villada Herşey En İnce Ayrıntısına Kadar Sorunsuzdu. Aksilikleri Sevmeyen Bir Kişi Olarak Bu Senede Villa Villam Üzerinden Bir Villa",
    name: "Yalçın Sünbül",
    rating: 5,
  },
  {
    text: "özellikle nur hanıma çok teşekkürlerimi sunarım sabırla yardımcı oldu kendileri işlerinde kolaylıklar dilerim💖",
    name: "Yeliz Koçalan",
    rating: 5,
  },
  {
    text: "Çok memnun kaldık. Her şeyi ile mükemmeldi. Ev sahibi hanımefendi de gayet ilgili ve nazik bin hanımefendi. Herkese tavsiye ediyoruz.",
    name: "Sefa OCAKDEN",
    rating: 5,
  },
  {
    text: "Bugün tatilimiz için çok güzel bir ev kiraladık bu işlemler esnasında bize inanılmaz yardımcı oldular belki 30 kere aradım her seferinde nazikce ve bıkmadan iletişim kurdular özellikle Sezen Hanıma inceliği ve sabrı için teşekkür ediyorum iyi ki varsın Villa Villam🫠Trabzondan Narin Öğretmen",
    name: "Narin Yav",
    rating: 5,
  },
  {
    text: "Çok Hızlı ve Güvenilir şekilde ilerledi herşey sms ve mail olarak anlık bilgilendirildim tebrik ederim 👍",
    name: "ES HİDROLİK LTD.ŞTİ",
    rating: 5,
  },
  {
    text: "Çiğdem hanım çok yardımcı oldu, çözüm odaklı yaklaştı kendisine çokl teşekkür ediyorum.",
    name: "Burak Uzunoğlu",
    rating: 5,
  },
  {
    text: "Rezervasyon sürecinde ilgi alakaları gerçekten çok iyi memnun kaldım ödemeye Rezervasyon sürecinde kartta tek çekim yapıp taksit imkanı da olması bal kaymak gibi güzel oldu",
    name: "Muhammet İlengiz",
    rating: 5,
  },
  {
    text: "Her şey güzeldi. Her şey için teşekkür ederiz. Necip Bey güzel bir şekilde ağırladı ilgilendi bizlerle. Villa gayet temiz ve güzel kullanışlıydı herkese tavsiye edebilirim.",
    name: "emin özmen",
    rating: 5,
  },
  {
    text: "Kiralama süreci çok pratik oldu, henüz konaklama yapmadım ama müşteri ilişkileri son derece hızlı ve çözüm odaklı.",
    name: "zehra zeynep keklikkıran",
    rating: 5,
  },
  {
    text: "Villa müthiş temiz yeni ve ferah dı…havuzu efsaneydi, tertemiz ve her sabahda temizlendi. herşey eksiksiz mevcuttu. ev sahibi çok cana yakın güler yüzlü ve ilgiliydi…inşallah tekrar görüşmek üzere. Buda 1-2 resim bizim çektiğimiz",
    name: "Canan Karaman",
    rating: 5,
  },
  {
    text: "İşlemler hızlı ve pratik bir şekilde halloldu. Rezervasyon talebi gönderir göndermez hemen dönüş sağlandı. Aynı zamanda whatsappta da aynı hızda dönüş sağlamaktalar.",
    name: "Hanife DELİPOYRAZ",
    rating: 5,
  },
  {
    text: "Her konuda titizlikle yardımcı oldukları için teşekkür ederim müşteri danışmanları gerçekten çok naif ve anlatışlıydı",
    name: "Faruk Ertürk",
    rating: 5,
  },
  {
    text: "Sorduğum tüm sorulara titizlikle cevap aldım. Müşteri ilginiz için teşekkür ederim. Tatil tarihimin gelmesini dört gözle bekliyorum.",
    name: "Hilal Karslı",
    rating: 5,
  },
  {
    text: "Rezervasyon konusunda çok yardımcı oldular ve çok hızlı dakik işlemler gerçekleşti.Tatil tarihinde kalacağımız yer için gerekli memnuniyet belirtilevektir.",
    name: "Tuğçe Şen",
    rating: 5,
  },
  {
    text: "İşlemlerimi Sezen hanım ile yaptım. Çok ilgi ve alakalı bir yaklaşımı vardı. Teşekkür ederim.",
    name: "Göktuğ Akyıldız",
    rating: 5,
  },
  {
    text: "Her konuda çok ilgili davranıldı. Rezervasyon süreci ve iletişim çok hızlıydı. Her şey için teşekkürler",
    name: "Doğu Aydın",
    rating: 5,
  },
  {
    text: "Balayı için Nisan ayınna ismi kaya trio olan villayı kiraladım çok yardımcı oldular umarım villa da sorun çıkmaz teşekkür ederim kendilerine",
    name: "İlker Özçelik",
    rating: 5,
  },
  {
    text: "Villa Şükran Hatun'u kullandık hem ev sahiplerinden hem villadan çok memnun kaldık.Ev sahiplerinin(Melek Hanım ve Fatih Bey) ilgi ve alakası çok güzeldi.Çok samimilerdi.Kendilerine çok teşekkür ederiz.Umarım tekrar görüşürüz.",
    name: "Veli İhsan",
    rating: 5,
  },
  {
    text: "Harika ve ilgili bir süreçti, İrem hanıma sonsuz teşekkürler her anımızda yanımızda oldu",
    name: "berna ulucan",
    rating: 5,
  },
  {
    text: "Müşteri hizmetleri bizimle çok ilgilendi her sorumuza özenle cevap verildi Sezen hanım da ayrıca teşekkür ederiz ☺️",
    name: "Gokhan Tok",
    rating: 5,
  },
  {
    text: "Villa villamdan villa burçello villasını kiraladık çok memnun kaldık ev sahipleri çok yardımcı oldu ev temizdi ikramları için teşekkür ederiz tavsiye ediyorum",
    name: "Esma Nur",
    rating: 5,
  },
  {
    text: "Tek kelimeyle o kadar soru sormama rağmen iletişimden hiç kopmayan bir firma herşey için teşekkürler ellerinize sağlık kesinlikle tavsiye ederim",
    name: "Mücahit Rakipoğlu",
    rating: 5,
  },
  {
    text: "Tüm rezervasyon sürecimiz de bizimle çok iyi ilgilendiği için Cansel hanıma teşekkür ediyoruz",
    name: "Sinan Tırınk",
    rating: 5,
  },
  {
    text: "MÜŞTERİ TEMSİLCİSİ ARKADAŞLAR COK İLGİLİ BURADAN HEPSİNE ÇOK TEŞEKKÜR EDERİM",
    name: "Muhammed Uslu",
    rating: 5,
  },
  {
    text: "Henüz deneyim yaşamadık ama müşteri temsilcileri anında dönüş yapıyorlar ve çok ilgililer ben çok memnun kaldım deneyimimden sonrada yorum yapacağım",
    name: "Gül",
    rating: 5,
  },
  {
    text: "Hızlı ve güvenli bir şekilde rezervasyonumuzu tamamladık. Sezen hanım da çok ilgili ve bilgilendirici bir şekilde yardımcı oldu",
    name: "Elif Ş",
    rating: 5,
  },
  {
    text: "Hızlı geri dönüş ve ilgileri için çok teşekkür ederim. Çok memnun kaldım.",
    name: "Burak Köm",
    rating: 5,
  },
  {
    text: "gayet ilgililerdi bütün sorularımıza cevap bulduk i̇lgi ve alakadan çok memnunum.",
    name: "faki soylu",
    rating: 5,
  },
  {
    text: "Rezervasyon sürecinde gayet ilgili ve kibar iletişimleriyle çok yardımcı oldular özellikle sezen hanıma teşekkürler :)",
    name: "Kübra Kılıç",
    rating: 5,
  },
  {
    text: "Müşteri temsilcileri çok ilgiliydi bizimle çok ilgilendiler çok memnun kaldık ☺️🙏🏼",
    name: "Meryem Cellat",
    rating: 5,
  },
  {
    text: "Müşteri hizmetlerinden sezen hanım bizimle çok ilgilendi 10 güne aşkın hangi villayı tutsak diye kararsız kalmıştık kafamıza takılan tüm soruları cevapladı ne zaman wp üzerinden veya sesli olarak arasak hep hızlı bir şekilde dönüş yaptı ve gerçekten çok güler yüzlüydü çok ilgilendi tavsiye ederim.",
    name: "Vedat Tuğra",
    rating: 5,
  },
  {
    text: "Rezervasyon işlemini hızlı bir şekilde tamamladık. Sezen Hanım'a ilgi ve alakası için teşekkür ederim.",
    name: "Emre Karaarslan",
    rating: 5,
  },
  {
    text: "Çok güzel hizmet aldım çok güzel ilgileniyor sorularıma hemen cevap veriyorlar açıklayıcı ve net bir şekilde hızlı dönüşler yapıyorlar çok teşekkür ederim villa villam",
    name: "Oğuzhan Özer",
    rating: 5,
  },
  {
    text: "Ön ödeme aşamasındayım ve cok memnun kaldım tatilden sonra revize edeceğim Yaşadığımız En keyifli ve sorunsuz tatil deneyimini yaşattığı için Villa Four",
    name: "Fatih Şahin",
    rating: 5,
  },
  {
    text: "Rezervasyon aşamasında çok yardımcı oldular. İlgi ve alakaların dolayı villa villam müşteri hizmetlerine çok teşekkür ederim.",
    name: "Harun Buyukata",
    rating: 5,
  },
  {
    text: "Müşteri hizmetlerinin hızlı geridönüşleri ve yardımcı olmalarından dolayı teşekkür ederim",
    name: "Durak Şahin",
    rating: 5,
  },
  {
    text: "Villa villam üzerinden bulduğumuz villa portofinoda konaklama yaptık çok memnun kaldık villa büyüktü dizaynı çok hoşumuza gitti merkeze yakın olması bizim için tercih sebeplerin biriydi mevsim dolasıyla biz havuzu kullanamadık ama havuz",
    name: "Aslı Yazıcı",
    rating: 5,
  },
  {
    text: "Rezervasyon sürecini oldukça hızlı sürdüren personele çok teşekkür ederim tavsiye ederim",
    name: "Engin Can Akyüz",
    rating: 5,
  },
  {
    text: "Villa villam , ev sahibi ve Emeği geçen herkese çok teşekkür ediyoruz harika bir tatil deneyimi yaşadık yılın bütün yorgunluğunu attığım huzur dolu bir yuva idi günün her saati suda geçen kendimize özel bir tatil deneyimi yaşadık İlkan Tanç beye çok teşekkür ederiz.",
    name: "seyfeddin uygun",
    rating: 5,
  },
  {
    text: "İlgi ve alaka çok güzeldi villamızı kiraladık inşallah villada kaldıktan sonra da görüşlerimi buraya yazıcam",
    name: "Mert Yılmaz",
    rating: 5,
  },
  {
    text: "Hizmet hızlı ve çok iyiydi, her şey sorunsuz ilerledi. Teşekkürler 😄👍🏼",
    name: "Talha Karaca",
    rating: 5,
  },
  {
    text: "Güvenilir ve güzel bir site ilgileri çok güzel özellikle irem hanım her aşamayı detaylı olarak bildirdi yardımcı oldu harikasınız",
    name: "Hilal Sezgin",
    rating: 5,
  },
  {
    text: "Rezervasyon sürecinde bana yardımcı olan cevaplayan sahra hanıma çok teşekkür ederim .",
    name: "Tuğba Kaya",
    rating: 5,
  },
  {
    text: "Çok ilgililer sorulara anında cevap veriyorlar ve detaylar için iletişime geçiyorlar teşekkürler",
    name: "buket katanalp",
    rating: 5,
  },
  {
    text: "Rezervasyon sırasında ilgileri çok güzeldi herhangi bir sorun yaşamadım iletişim olarak başarılı",
    name: "Nehir can Eker",
    rating: 5,
  },
  {
    text: "Rezervasyon sürecinde bize sabırla yardımcı olan Sezen hanıma cok tesekkürler",
    name: "Tuba Yigito",
    rating: 5,
  },
  {
    text: "Villavillam ekibi ile çalışmak gerçekten çok keyifliydi. Rezervasyon sürecinden ödeme aşamasına kadar her şey son derece profesyonel ve şeffaf ilerledi. İletişimleri çok hızlı, samimi ve çözüm odaklı. Her soruma anında dönüş yaptılar ve tüm",
    name: "Ammar Afsa Yilmaz",
    rating: 5,
  },
  {
    text: "Keyifli ve hızlı bir rezervasyondu ilginen arkadaşa ayrıca teşekkür ediyorum güvenle tatilinizi planlayabilirsiniz",
    name: "Kübra Yılmaz",
    rating: 5,
  },
  {
    text: "Ben cok memnun kaldim herkesede tavsiye ederim👌",
    name: "Erkan Yurt",
    rating: 5,
  },
  {
    text: "Rezervasyon sürecinde Sena hanımın yardımlarından dolayı çok teşekkür ederim.",
    name: "Burak Köylü",
    rating: 5,
  },
  {
    text: "Sitenin fonksiyonel ve anlaşılabilir olması çok iyi. Talep oluşturunca hızlı bir geri dönüş sağlanması ve talep uygunluğundan sonraki süreçlerin işleyişi çok daha iyi ve güven verici. Gönül rahatlığıyla rezervasyonumuzu oluşturduk ve villa",
    name: "AYTEK ÖZÇOPUR",
    rating: 5,
  },
  {
    text: "Son derece güvenilir bir site. Çağrı merkezi çalışanları çözüm odaklı yaklaşım sunmaktadır. Ne zaman aradı isem ulaştım ve usanmadan bıkmadan sorularımızı içtenlikle cevapladılar. Çevremdeki herkese öneriyorum ve önermeye devam edeceğim. Teşekkür ederiz.",
    name: "Ufuk Altuner",
    rating: 5,
  },
  {
    text: "Villa villam müşteri hizmetleri 5 yıldızı sonuna kadar hak ediyor teşekkürler herşey için…",
    name: "İsmail Burak Şen",
    rating: 5,
  },
  {
    text: "yillardir villa villamdan kiraliyoruz ve hic bir zaman sorun yasamadik. gecen sene kiraliyip ön ödeme yapmistik ama geri iptal etmek zorunda kalmistik. ön ödemeyi bu sene kullandik. yani dediklerinde durdular o para yok olmadi bunun icin",
    name: "Nhl s.",
    rating: 5,
  },
  {
    text: "Yaptığım her işlemden sonra gerekli bilgileri anında bana ulaştırdılar. Rezervasyon sırasında da herhangi bir sorun yaşamadım. 2 sene önce de bu siteden villa kiralamıştık o zaman da bir sorun yaşamamıştık. Bu siteyi gönül rahatlığıyla tavsiye ederim. Çalışanların ilgi ve alakasından ötürü teşekkür ederim.",
    name: "Selver Erdem",
    rating: 5,
  },
  {
    text: "Kiralama sürecindeki detaylı bilgi paylaşımı ve müşteri temsilcisi yaklaşımından gayet memnun kaldım, kolay ilerledi rezervasyon aşaması tam destek gördüm. Tatil sonrası deneyimimi paylaşırım, teşekkürler.",
    name: "Didem Denizli",
    rating: 5,
  },
];
